type Permissions = {
  possibleGlobalPost: boolean
}

// ユーザー権限
export enum UserRole {
  user = 1,
  pro = 2,
  systemAdmin = 3
}

// 契約タイプ
export enum UserContractType {
  advance = 1,
  free = 2
}

export type UserBase = {
  id: number
  name: string
}

export type User = UserBase & {
  private_name: string
  avatar: string
  organization_id: string
  organization_name: string
  company_name: string
  used_nickname: string
  profile: string | undefined
  home_url: string | undefined
  permissions: Permissions
  role: UserRole
  user_contract_type: UserContractType
  userPublicId?: string
  is_allow_ai_chat?: boolean
  /** @grtx.jp かつ閲覧権限があり、学習ダッシュボードを開けるか */
  is_allow_dashboard?: boolean
  /** サイドバーに学習ダッシュボードの導線を出すか。本番も同じ権限条件 */
  is_show_dashboard_link?: boolean
}

export type UserSummary = {
  id: number
  name: string
}

export type MyCompanyUser = {
  id: number
  name: string
  avatar: string
  lastMentionedAt?: string
  isActive: boolean
  commentCount?: number
  replyCount?: number
  questionCount?: number
  totalActivityCount?: number
  paginationActivityCount?: number
}
